export default {
  label: {
    router: {
      access: 'Acesso',
      dashboard: 'Dashboard',
    },
  },
};
